import { PropsWithChildren } from 'react';

interface StyledListHeaderProps {
  title: string;
  subTitle: string;
}

const StyledListHeader = ({
  title,
  subTitle,
  children,
}: PropsWithChildren<StyledListHeaderProps>) => {
  return (
    <div className="flex flex-col md:flex-row w-full justify-between h-auto p-6 gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-semibold text-gray-950">{title}</h1>
        <p className="text-sm leading-4 text-gray-600">{subTitle}</p>
      </div>
      <div className="flex flex-col md:flex-row gap-4">{children}</div>
    </div>
  );
};

export default StyledListHeader;
